import {inject, Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {LessonFacetDataEntity} from './models';
import {OctopusConnectService} from 'octopus-connect';

const ENDPOINT = 'lesson_facets';

export type LessonFacetsFilters = Partial<{
    concept: number | number[],
    level: number | number[]
}>;

@Injectable({
    providedIn: 'root'
})
export class LessonFacetsService {

    private octopusConnect = inject(OctopusConnectService);

    public getLessonFacets(options: { filters: LessonFacetsFilters }) {
        return this.octopusConnect.loadCollection(ENDPOINT, options.filters).pipe(
            map((dataCollection) => {
                if (dataCollection.entities.length === 0) {
                    return null;
                }

                return dataCollection.entities[0] as LessonFacetDataEntity;
            })
        );
    }
}
